export default function Stack({ children, as = "div" }) {
  const Component = as;
  return <Component className="flex flex-col gap-4">{children}</Component>;
}
